import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5ce20c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-list-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hako-icon",
  src: "/Ylalogo.png"
}, null, -1))
const _hoisted_3 = { class: "category-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "category-sort-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Järjestysten muokkaus", -1))
const _hoisted_18 = { class: "logout-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoDropdown = _resolveComponent("HakoDropdown")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_GuideCreation = _resolveComponent("GuideCreation")!
  const _component_HakoModal = _resolveComponent("HakoModal")!
  const _component_CategoryCreation = _resolveComponent("CategoryCreation")!
  const _component_AskCategoryRemoval = _resolveComponent("AskCategoryRemoval")!
  const _component_AskGuideRemoval = _resolveComponent("AskGuideRemoval")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.orderEdit)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.categories, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "category",
                key: category.id
              }, [
                _createElementVNode("div", {
                  onClick: _withModifiers(($event: any) => (_ctx.toggleCategory(category)), ["stop"]),
                  class: _normalizeClass(["main-category level-1", _ctx.isSelectedCategoryGuide(category.rootGuideId)])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(category.name), 1),
                    _createVNode(_component_HakoBsIcon, {
                      class: "list-chevron",
                      size: 80,
                      icon: _ctx.categoryChevron(category.id)
                    }, null, 8, ["icon"])
                  ]),
                  (!category.published && _ctx.$userIsSuper())
                    ? (_openBlock(), _createBlock(_component_HakoBsIcon, {
                        key: 0,
                        theme: "secondary",
                        icon: "envelope-slash-fill"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$userIsSuper())
                    ? (_openBlock(), _createBlock(_component_HakoDropdown, {
                        key: 1,
                        "menu-on-right": "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        style: {"margin-left":"8px"}
                      }, {
                        customButton: _withCtx(() => [
                          _createVNode(_component_HakoBsIcon, {
                            class: "hover-link",
                            theme: "success",
                            size: 120,
                            icon: "gear"
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.createNewGuide(category)), ["prevent"])
                            }, [
                              _createVNode(_component_HakoBsIcon, { icon: "plus-circle" }),
                              _createTextVNode(" Uusi ohje ")
                            ], 8, _hoisted_5)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.editCategory(category)), ["prevent"])
                            }, [
                              _createVNode(_component_HakoBsIcon, { icon: "pencil" }),
                              _createTextVNode(" Muokkaa ")
                            ], 8, _hoisted_6)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.deleteCategory(category)), ["prevent"])
                            }, [
                              _createVNode(_component_HakoBsIcon, { icon: "trash" }),
                              _createTextVNode(" Poista kategoria ")
                            ], 8, _hoisted_7)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_4),
                (category.guides && category.guides.length > 0 && _ctx.isCategoryOpen(category.id))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.guides, (guide) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["guide-link level-2", _ctx.isSelectedGuide(guide)]),
                        key: guide.id
                      }, [
                        (!guide.categoryRoot)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_router_link, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-panel'))),
                                to: '/artikkeli/'+guide.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(guide.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              (!guide.published && _ctx.$userIsSuper())
                                ? (_openBlock(), _createBlock(_component_HakoBsIcon, {
                                    key: 0,
                                    theme: "secondary",
                                    icon: "envelope-slash-fill"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.$userIsSuper())
                                ? (_openBlock(), _createBlock(_component_HakoDropdown, {
                                    key: 1,
                                    "menu-on-right": "",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                                    style: {"margin-left":"8px"}
                                  }, {
                                    customButton: _withCtx(() => [
                                      _createVNode(_component_HakoBsIcon, {
                                        class: "hover-link",
                                        theme: "success",
                                        size: 120,
                                        icon: "gear"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.editGuide(guide, category.id)), ["prevent"])
                                        }, [
                                          _createVNode(_component_HakoBsIcon, { icon: "pencil" }),
                                          _createTextVNode(" Muokkaa ")
                                        ], 8, _hoisted_8)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.deleteGuide(guide)), ["prevent"])
                                        }, [
                                          _createVNode(_component_HakoBsIcon, { icon: "trash" }),
                                          _createTextVNode(" Poista ohje ")
                                        ], 8, _hoisted_9)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  : _createCommentVNode("", true),
                (category.children.length > 0 && _ctx.isCategoryOpen(category.id))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(category.children, (level2) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: level2.id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["level-2", _ctx.isSelectedCategoryGuide(level2.rootGuideId)]),
                          onClick: _withModifiers(($event: any) => (_ctx.toggleCategory(level2)), ["stop"])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, _toDisplayString(level2.name), 1),
                            _createVNode(_component_HakoBsIcon, {
                              class: "list-chevron",
                              size: 80,
                              icon: _ctx.categoryChevron(level2.id)
                            }, null, 8, ["icon"])
                          ]),
                          (!level2.published && _ctx.$userIsSuper())
                            ? (_openBlock(), _createBlock(_component_HakoBsIcon, {
                                key: 0,
                                theme: "secondary",
                                icon: "envelope-slash-fill"
                              }))
                            : _createCommentVNode("", true),
                          (!level2.categoryRoot)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.$userIsSuper())
                                  ? (_openBlock(), _createBlock(_component_HakoDropdown, {
                                      key: 0,
                                      "menu-on-right": "",
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                      style: {"margin-left":"8px"}
                                    }, {
                                      customButton: _withCtx(() => [
                                        _createVNode(_component_HakoBsIcon, {
                                          class: "hover-link",
                                          theme: "success",
                                          size: 120,
                                          icon: "gear"
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (_ctx.createNewGuide(level2)), ["prevent"])
                                          }, [
                                            _createVNode(_component_HakoBsIcon, { icon: "plus-circle" }),
                                            _createTextVNode(" Uusi ohje ")
                                          ], 8, _hoisted_11)
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (_ctx.editCategory(level2)), ["prevent"])
                                          }, [
                                            _createVNode(_component_HakoBsIcon, { icon: "pencil" }),
                                            _createTextVNode(" Muokkaa ")
                                          ], 8, _hoisted_12)
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (_ctx.deleteCategory(level2)), ["prevent"])
                                          }, [
                                            _createVNode(_component_HakoBsIcon, { icon: "trash" }),
                                            _createTextVNode(" Poista kategoria ")
                                          ], 8, _hoisted_13)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_10),
                        (level2.guides && level2.guides.length > 0 && _ctx.isCategoryOpen(level2.id))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(level2.guides, (guide) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: guide.id
                              }, [
                                (!guide.categoryRoot)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["guide-link level-3", _ctx.isSelectedGuide(guide)])
                                    }, [
                                      _createVNode(_component_router_link, {
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-panel'))),
                                        to: '/artikkeli/'+guide.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(guide.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      (!guide.published && _ctx.$userIsSuper())
                                        ? (_openBlock(), _createBlock(_component_HakoBsIcon, {
                                            key: 0,
                                            theme: "secondary",
                                            icon: "envelope-slash-fill"
                                          }))
                                        : _createCommentVNode("", true),
                                      (!level2.categoryRoot)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (_ctx.$userIsSuper())
                                              ? (_openBlock(), _createBlock(_component_HakoDropdown, {
                                                  key: 0,
                                                  "menu-on-right": "",
                                                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                                  style: {"margin-left":"8px"}
                                                }, {
                                                  customButton: _withCtx(() => [
                                                    _createVNode(_component_HakoBsIcon, {
                                                      class: "hover-link",
                                                      theme: "success",
                                                      size: 120,
                                                      icon: "gear"
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("a", {
                                                        class: "dropdown-item",
                                                        href: "#",
                                                        onClick: _withModifiers(($event: any) => (_ctx.editGuide(guide, level2.id)), ["prevent"])
                                                      }, [
                                                        _createVNode(_component_HakoBsIcon, { icon: "pencil" }),
                                                        _createTextVNode(" Muokkaa ")
                                                      ], 8, _hoisted_14)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("a", {
                                                        class: "dropdown-item",
                                                        href: "#",
                                                        onClick: _withModifiers(($event: any) => (_ctx.deleteGuide(guide)), ["prevent"])
                                                      }, [
                                                        _createVNode(_component_HakoBsIcon, { icon: "trash" }),
                                                        _createTextVNode(" Poista ohje ")
                                                      ], 8, _hoisted_15)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : (_ctx.orderEdit && _ctx.$userIsSuper())
            ? (_openBlock(), _createBlock(_component_draggable, {
                key: 1,
                modelValue: _ctx.categories,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.categories) = $event)),
                group: "blocks",
                onStart: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drag=true)),
                onEnd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.drag=false)),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateOrderIndexes())),
                "item-key": "orderIndex"
              }, {
                item: _withCtx(({element}) => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", null, _toDisplayString(element.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
        (_ctx.$userIsSuper())
          ? (_openBlock(), _createBlock(_component_HakoButton, {
              key: 2,
              class: "mt-2",
              sm: "",
              "is-block": "",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createNewCategory()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Lisää kategoria "),
                _createVNode(_component_HakoBsIcon, { icon: "plus" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.$userIsSuper())
          ? (_openBlock(), _createBlock(_component_HakoButton, {
              key: 3,
              class: "mt-2",
              sm: "",
              "is-block": "",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.orderEdit = !_ctx.orderEdit))
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(),
                _createVNode(_component_HakoBsIcon, { icon: "list" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.$userIsSuper())
          ? (_openBlock(), _createBlock(_component_HakoButton, {
              key: 4,
              class: "mt-2",
              sm: "",
              "is-block": "",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToControlPanel()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ohjauspaneeli "),
                _createVNode(_component_HakoBsIcon, { icon: "gear" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_HakoButton, {
          theme: "danger",
          sm: "",
          "is-block": "",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.logOut()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Kirjaudu ulos")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_HakoModal, {
      title: "Ohje",
      modelValue: _ctx.showGuideCreation,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showGuideCreation) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_GuideCreation, {
          onNewGuide: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getCategoriesFromDb())),
          chosenguideprop: _ctx.chosenGuide,
          chosencategoryprop: _ctx.chosenCategory,
          categoriesprop: _ctx.categories
        }, null, 8, ["chosenguideprop", "chosencategoryprop", "categoriesprop"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_HakoModal, {
      title: "Uusi kategoria",
      modelValue: _ctx.showCategoryCreation,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showCategoryCreation) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CategoryCreation, {
          editcategoryprop: _ctx.chosenCategory,
          onEditCategory: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getCategoriesFromDb())),
          onNewCategory: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getCategoriesFromDb()))
        }, null, 8, ["editcategoryprop"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_HakoModal, {
      title: "Kategorian poisto",
      modelValue: _ctx.showCategoryDeletion,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showCategoryDeletion) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AskCategoryRemoval, {
          onCategoryDeleted: _cache[19] || (_cache[19] = ($event: any) => (_ctx.getCategoriesFromDb())),
          chosencategoryprop: _ctx.chosenCategory,
          categoriesprop: _ctx.categories
        }, null, 8, ["chosencategoryprop", "categoriesprop"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_HakoModal, {
      title: "Ohjeen poisto",
      modelValue: _ctx.showGuideDeletion,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showGuideDeletion) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AskGuideRemoval, {
          onGuideDeleted: _cache[21] || (_cache[21] = ($event: any) => (_ctx.getCategoriesFromDb())),
          chosenguideprop: _ctx.chosenGuide
        }, null, 8, ["chosenguideprop"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}